<adapt-universal-dashboard-element name="Meeting guidance"
                                   [disableClick]="((canEditTeamGuidance$ | async) === false)"
                                   (headerClicked)="editTeamMeetingGuidance()"
                                   linkText="Define the meeting guidance"
                                   [contentCard]="isAlto">

    <div *adaptLoadingUntilFirstEmit="let teamMeetingGuidance of teamMeetingGuidance$">
        @if (teamMeetingGuidance && teamMeetingGuidance?.containsGuidance) {
            <div>
                @if (teamMeetingGuidance.meetingIntent) {
                    <h4>Why do we meet?</h4>
                }
                <div class="mb-3"
                     [froalaView]="teamMeetingGuidance.meetingIntent"></div>

                @if (teamMeetingGuidance.meetingGuidelines) {
                    <h4>How will we behave when we meet?</h4>
                }
                <div class="mb-3"
                     [froalaView]="teamMeetingGuidance.meetingGuidelines"></div>

                @if (teamMeetingGuidance.meetingFrequency) {
                    <h4>How frequently will we meet?</h4>
                }
                <div class="mb-3"
                     [froalaView]="teamMeetingGuidance.meetingFrequency"></div>

                @if (teamMeetingGuidance.decisionProcess) {
                    <h4>How will we make decisions?</h4>
                }
                <div class="mb-3"
                     [froalaView]="teamMeetingGuidance.decisionProcess"></div>
            </div>
        } @else {
            <adapt-call-to-action-inline>
                <p>Setting your team's meeting guidance allows the team to define:</p>
                <ul class="list-content">
                    <li>The purpose for team meetings</li>
                    <li>The expected behaviour during team meetings</li>
                    <li>How frequently the team meets</li>
                    <li>The decision-making process</li>
                </ul>
                @if (!isAlto && !embedded) {
                    <button adaptCallToActionButton
                            adaptButtonIcon="edit"
                            *adaptIfAuthorised="editTeamKanban;Entity:team$ | async"
                            (click)="editTeamMeetingGuidance()">
                        Define the meeting guidance
                    </button>
                }
            </adapt-call-to-action-inline>
        }
    </div>
</adapt-universal-dashboard-element>
